module.exports = new __parcel__URL__("open-hihat_10.4ec7a4eb.mp3").toString();